/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { navigate } from "@reach/router"
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

const Header = ({ classes }) => {
  const [value, setValue] = React.useState(0);
  const { header, root } = classes;

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  return (
    <React.Fragment>
      <div className={header}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          indicatorColor="primary"
          classes={{ root }}
        >
          <Tab label="User Profile" onClick={() => navigate("/userProfile")} value={0} />
          <Tab label="Navigation" onClick={() => navigate("/location")} value={1} />
          <Tab label="Dialogs" onClick={() => navigate("/dialog")} value={2} />
          <Tab label="Hands Free" onClick={() => navigate("/handsFree")} value={3} />
          <Tab label="Ip App Info" onClick={() => navigate("/ipappinfo")} value={4} />
          <Tab label="Codecs" onClick={() => navigate("/codecs")} value={5} />
          <Tab label="Geolocation" onClick={() => navigate("/geolocation")} value={6} />
          <Tab label="VIS" onClick={() => navigate("/vis")} value={7} />
          <Tab label="Keyboard" onClick={() => navigate("/keyboard")} value={8} />
          <Tab label="SoundBeep" onClick={() => navigate("/sounds")} value={9} />
          <Tab label="PDF" onClick={() => navigate("/pdf")} value={10} />
          {/* <Tab label="BLE" onClick={() => navigate("/ble")} value={11} /> */}
          <Tab label="WindowOpen/Close" onClick={() => navigate("/windowOpenClose")} value={12} />
          <Tab label="Notifications" onClick={() => navigate("/notifications")} value={13} />
          <Tab label="Screen Resolution" onClick={() => navigate("/resolution")} value={14} />
          <Tab label="Video" onClick={() => navigate("/video")} value={15} />
        </Tabs>
      </div>
    </React.Fragment>
  );
};

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);
